import React, { useContext } from 'react';
import DocumentUploadContext from '../../context/DocumentUpload/documentUploadContext';
import AccountServices from '../../pages/AccountServicesMain';

const AccountServicesForm = () => {
  const documentUploadContext = useContext(DocumentUploadContext);
  const currentURL = window.location.href;
  switch (documentUploadContext.step) {
    case 0:
      return <AccountServices />;
    default:
      return <h1>{''}</h1>;
  }
};
export default AccountServicesForm;
